import { EntityProject } from "../../entity/EntityProject";

export class DtoProjectsPutRes extends EntityProject {}
